import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import "./style.scss";
import uris from "../../../../config/uris";

const PaymentSuccess = () => {
    const navigate = useNavigate();

    useEffect(() => {
        sessionStorage.removeItem('stripeCheckoutUrl');
        setTimeout(() => {
            navigate(uris?.companyResearch);
        }, 5000);
    }, []);

    return (
        <div className="payment-success-card">
            <div className="payment-success-content">
                <div className="card-title">Payment Successful</div>
                <div className="card-description">Thank you for your purchase! You will be redirected to your dashboard shortly.</div>
            </div>
        </div>
    )
}

export default PaymentSuccess;